import type { ReactNode } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from 'src/components/ui/popover';
import { T } from 'gt-react';
import { formatPermissionSubjectLabel } from './permissionDisplay';

export type PermissionEntry = {
  action: string;
  subject: string;
};

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function PermissionListPopover({
  permissions,
  children,
  side = 'bottom',
}: {
  permissions: PermissionEntry[];
  children: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
}) {
  if (permissions.length === 0) return <>{children}</>;

  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent side={side} className="w-auto p-3" align="start">
        <p className="text-xs font-medium text-muted-foreground mb-2">
          <T context="heading in permission list popover">
            Required Permissions
          </T>
        </p>
        <table className="text-xs">
          <tbody>
            {permissions.map((p) => (
              <tr key={`${p.action}:${p.subject}`}>
                <td className="pr-4 py-0.5 font-medium">
                  {capitalize(p.action)}
                </td>
                <td className="py-0.5 text-muted-foreground">
                  {formatPermissionSubjectLabel(p.subject)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </PopoverContent>
    </Popover>
  );
}
